import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * A escala de texto do painel (`spec/17` §6: 11 · 14 · 16 · 18 · 22 · 28 · 38) é custom.
 * O `twMerge` de fábrica não a conhece, cai no validador permissivo de `text-color` e
 * trata `text-38` e `text-gold` como o MESMO grupo: o último ganha e o tamanho some.
 * Registrar todos os tamanhos em `font-size` é o que devolve o merge correto
 * (`cn('text-38', 'text-gold')` mantém os dois; `cn('text-22', 'text-38')` mantém 38).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['10', '11', '12', '13', '14', '15', '16', '18', '19', '22', '28', '38'] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
